export class clientMaster{
    ID: number;
    CLIENT_ID: number;
    NAME: string;
    MOBILE_NO: number;
    EMAIL_ID: string;
    INDUSTRY_NAME: string;
    INDUSTRY_ADDRESS: string;
    INDUSTRY_CITY: string;
    INDUSTRY_PINCODE: number;
    BILLING_MODE: string= "F";
    IS_ACTIVE: boolean;
}